import axios from 'axios'

const URL_PATH = 'api/atas/documentos/anexo'
class AnexosApiClient {
	async buscarAnexosPorDocumentoId(idDocumento) {
		const { data } = await axios.get(`${URL_PATH}/${idDocumento}`)
		return data
	}
	async adicionarAnexo(documentoComAnexo) {
		return await axios.post(`${URL_PATH}/anexo`, documentoComAnexo)
	}
	async criar(documentoComAnexo) {
		return await axios.post(`${URL_PATH}`, documentoComAnexo)
	}
}

export default new AnexosApiClient()
